module.exports = __webpack_public_path__ + "img/teams_tree_empty.a7ed92c3.svg";